import request from '@/utils/request'

// 添加提醒设置
export function addRemindSettings(data) {
    return request({
        url: '/system/remind/settings/add',
        method: 'post',
        data,
    })
}

// 查询单位提醒设置分页
export function getRemindSettingsPage(params) {
    return request({
        url: '/system/remind/settings/page',
        method: 'get',
        params,
    })
}

// 删除单位提醒设置
export function deleteRemindSettings(data) {
    return request({
        url: '/system/remind/settings/delete',
        method: 'post',
        data,
    })
}
